import { render, staticRenderFns } from "./DadosIniciais.vue?vue&type=template&id=009ab172&scoped=true"
import script from "./DadosIniciais.vue?vue&type=script&lang=js"
export * from "./DadosIniciais.vue?vue&type=script&lang=js"
import style0 from "./DadosIniciais.vue?vue&type=style&index=0&id=009ab172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009ab172",
  null
  
)

export default component.exports